// extracted by mini-css-extract-plugin
export var chevron = "_kh-2";
export var chevronRotated = "_kh-3";
export var header = "_kh-1";
export var section = "_kh-0";